import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useInvoice } from '../context/InvoiceContext';

const Register = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [loginId, setLoginId] = useState('');
  const [loginIdManuallyEdited, setLoginIdManuallyEdited] = useState(false);
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { register } = useInvoice();
  const navigate = useNavigate();

  const handleFirstNameChange = (e) => {
    const value = e.target.value;
    setFirstName(value);
    if (!loginIdManuallyEdited) {
      setLoginId(value.toLowerCase().replace(/\s+/g, ''));
    }
  };

  const handleLoginIdChange = (e) => {
    setLoginId(e.target.value);
    setLoginIdManuallyEdited(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const success = await register(firstName, lastName, loginId, password);
    setIsLoading(false);
    if (success) {
      navigate('/dashboard');
    }
  };

  return (
    <div className="flex-center" style={{ minHeight: '100vh', padding: 'var(--spacing-md)', backgroundColor: 'var(--color-gray-50)' }}>
      <div className="card" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="text-center mb-lg">
          <img
            src="/berlinr-logo.png"
            alt="BERLINR"
            style={{
              height: '80px',
              width: 'auto',
              margin: '0 auto var(--spacing-lg)',
              display: 'block'
            }}
          />
          <h2>Create Account</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-2 gap-md">
            <div className="form-group">
              <label className="form-label">First Name</label>
              <input
                type="text"
                className="form-input"
                value={firstName}
                onChange={handleFirstNameChange}
                required
                disabled={isLoading}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                className="form-input"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Login ID</label>
            <input
              type="text"
              className="form-input"
              value={loginId}
              onChange={handleLoginIdChange}
              required
              disabled={isLoading}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              disabled={isLoading}
            />
            <small className="text-secondary">Minimum 6 characters</small>
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-block btn-lg"
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="flex-center gap-sm">
                <div className="spinner spinner-sm"></div>
                Creating account...
              </span>
            ) : (
              'Register'
            )}
          </button>
        </form>

        <div className="divider"></div>

        <p className="text-center text-secondary">
          Already have an account?{' '}
          <Link to="/login" className="text-primary">
            Login here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
